import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NgxsModule } from '@ngxs/store';
import { NgxIndexedDBModule } from 'ngx-indexed-db';

import { DataCollectionState } from './+state/data-collection.state';
import { FormTemplateModalComponent } from './components/form-template-modal/form-template-modal.component';
import { idbConfig } from './constants/idb.config';
import { DataCollectionRoutingModule } from './data-collection-routing.module';
import { DataCollectionComponent } from './data-collection.component';
import { CreateInspectionService } from './services/create-inspection.service';
import { DataCollectionFacadeService } from './services/data-collection-facade.service';
import { DataCollectionTemplatesStoreService } from './services/data-collection-templates-store.service';
import { DataCollectionsStoreService } from './services/data-collections-store.service';
import { InspectionsService } from './services/inspections.service';
import { LoaderService } from './services/loader.service';
import { PushHandlerService } from './services/push-handler.service';
import { TemplatesService } from './services/templates.service';

@NgModule({
    declarations: [
        DataCollectionComponent,
        FormTemplateModalComponent,
    ],
    imports: [
        CommonModule,
        IonicModule,
        DataCollectionRoutingModule,
        NgxIndexedDBModule.forRoot(idbConfig),
        NgxsModule.forFeature([DataCollectionState]),
    ],
})
export class DataCollectionModule {
    // NOTE: preload services.
    constructor(
        private readonly dataCollectionFacadeService: DataCollectionFacadeService,
        private readonly dataCollectionsStoreService: DataCollectionsStoreService,
        private readonly dataCollectionTemplatesStoreService: DataCollectionTemplatesStoreService,
        private readonly loaderService: LoaderService,
        private readonly pushHandlerService: PushHandlerService,
    ) { }

    public static forRoot(): ModuleWithProviders<DataCollectionModule> {
        return {
            ngModule: DataCollectionModule,
            providers: [
                CreateInspectionService,
                DataCollectionFacadeService,
                DataCollectionsStoreService,
                DataCollectionTemplatesStoreService,
                InspectionsService,
                LoaderService,
                PushHandlerService,
                TemplatesService,
            ],
        };
    }
}
